import template from './ap-prices-check.html.twig';
import './ap-styles.css';
const { Criteria } = Shopware.Data;
Shopware.Component.register('ap-prices-check', {
    template,
    inject: ['repositoryFactory'],
    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },
    data() {
        return {
            productNumber: '',
            addressNumber: '',
            productQuantity: 0,
            countryId: 0,
            languageId: 0,
            debugFlag: 0,
            isLoading: false,
            isConfigLoading: false,
            errorMessage: '',
            isError: false,
            isConfigError: false,
            processConfigSuccess: false,
            processSuccess: false,
            showResultsContainer: false,
            showConfigResultsContainer: false,
            dataHeadResult: [],
            errorConfigMessage: [],
            warningConfigMessage: [],
            successConfigMessage: [],
            dataBodyResult: [],
            dataAddressInfoResult: [],
            dataProductInfoResult: [],
            dataDiscountHeadResult: [],
            dataDiscountBodyResult: [],
            dataTaxResult: [],
            country: null,
            language: null
        };
    },
    computed: {
        countryRepository() {
            return this.repositoryFactory.create('country');
        },
        languageRepository() {
            return this.repositoryFactory.create('language');
        },
        apCountryCriteria() {
            const criteria = new Criteria();
            criteria.addFilter(Criteria.not(
                'AND',
                [
                    Criteria.equals('customFields', null)
                ]
            ));
            return criteria;
        },
        apLanguageCriteria() {
            const criteria = new Criteria();
            criteria.addFilter(Criteria.not(
                'AND',
                [
                    Criteria.equals('customFields', null)
                ]
            ));
            return criteria;
        }
    },
    methods: {
        apOnClickFetch() {
            this.isLoading = true;
            this.isError = false;
            this.isConfigError = false;
            this.showResultsContainer = false;
            this.showConfigResultsContainer = false;
            const httpClient = Shopware.Application.getContainer('init').httpClient;
            const config = {
                url: '/ap/fetch-prices',
                method: 'get',
                baseURL: Shopware.Context.api.apiPath.replace('/api', ''),
                headers: {'X-Requested-With': 'XMLHttpRequest'},
                params: {
                    PN: this.productNumber,
                    CN: this.addressNumber,
                    QTY: this.productQuantity,
                    LD: this.countryId,
                    LG: this.languageId,
                    DG: this.debugFlag
                },
                timeout: 30000,
                validateStatus: function (status) {
                    return status >= 200 && status < 300; // default
                }
            };
            httpClient.request(config).then((response) => {
                return this.apHandleResponse(response);
            });
        },

        apHandleResponse(response) {
            this.isLoading = false;
            this.showResultsContainer = true;
            this.dataHeadResult = [];
            this.errorConfigMessage = [];
            this.successConfigMessage = [];
            this.warningConfigMessage = [];
            this.dataBodyResult = [];
            this.dataDiscountHeadResult = [];
            this.dataDiscountBodyResult = [];
            this.dataTaxResult = [];
            let apDataResult = response.data;
            if (apDataResult === null || apDataResult === undefined) {
                this.isError = true;
                this.errorMessage = 'ap-prices.error.invalidResponse';
                return;
            }

            if (apDataResult.error) {
                this.isError = true;
                this.errorMessage = apDataResult.message;
                return;
            }
            this.isError = false;
            this.dataProductInfoResult = apDataResult.productInfo;
            this.dataAddressInfoResult = apDataResult.addressInfo;
            for (let key in apDataResult.dataHead) {
                if (apDataResult.dataHead.hasOwnProperty(key)) {
                    this.dataHeadResult.push(apDataResult.dataHead[key]);
                }
            }
            this.dataTaxResult = apDataResult.taxInfo;
            for (let key in apDataResult.dataBody) {
                if (apDataResult.dataBody.hasOwnProperty(key)) {
                    let bodyCollector=[]
                    for (let key2 in apDataResult.dataBody[key]) {
                        if (apDataResult.dataBody[key].hasOwnProperty(key2)) {
                            bodyCollector.push(apDataResult.dataBody[key][key2]);
                        }
                    }
                    this.dataBodyResult.push(bodyCollector);
                }
            }
            for (let key in apDataResult.dataDiscountHead) {
                if (apDataResult.dataDiscountHead.hasOwnProperty(key)) {
                    this.dataDiscountHeadResult.push(apDataResult.dataDiscountHead[key]);
                }
            }
            for (let key in apDataResult.dataDiscountBody) {
                if (apDataResult.dataDiscountBody.hasOwnProperty(key)) {
                    let bodyCollector=[]
                    for (let key2 in apDataResult.dataDiscountBody[key]) {
                        if (apDataResult.dataDiscountBody[key].hasOwnProperty(key2)) {
                            bodyCollector.push(apDataResult.dataDiscountBody[key][key2]);
                        }
                    }
                    this.dataDiscountBodyResult.push(bodyCollector);
                }
            }

        },
        apSaveFinish() {
            this.processSuccess = true;
        },
        apConfigFinish() {
            this.processConfigSuccess = true;
        },
        apOnClickConfigFetch() {
            this.isConfigLoading = true;
            this.isConfigError = false;
            this.isError = false;
            this.showResultsContainer = false;
            this.showConfigResultsContainer = false;
            const httpClient = Shopware.Application.getContainer('init').httpClient;
            const config = {
                url: '/ap/check-configs',
                method: 'get',
                baseURL: Shopware.Context.api.apiPath.replace('/api', ''),
                headers: {'X-Requested-With': 'XMLHttpRequest'},
                timeout: 30000,
                validateStatus: function (status) {
                    return status >= 200 && status < 300; // default
                }
            };
            httpClient.request(config).then((response) => {
                return this.apConfigHandleResponse(response);
            });
        },
        apConfigHandleResponse(response) {
            this.isConfigLoading = false;
            this.showConfigResultsContainer = true;
            this.showResultsContainer = false;
            this.dataBodyResult = [];
            this.dataHeadResult = [];
            this.errorConfigMessage = [];
            this.successConfigMessage = [];
            this.warningConfigMessage = [];
            this.isConfigError = true;
            let apConfigDataResult = response.data;
            if (apConfigDataResult === null || apConfigDataResult === undefined) {
                this.errorConfigMessage.push('ap-prices.error.invalidResponse');
                return;
            }
            for (let key in apConfigDataResult.error_messages) {
                this.errorConfigMessage.push(apConfigDataResult.error_messages[key]);
            }
            for (let key in apConfigDataResult.warning_messages) {
                this.warningConfigMessage.push(apConfigDataResult.warning_messages[key]);
            }
            for (let key in apConfigDataResult.success_messages) {
                this.successConfigMessage.push(apConfigDataResult.success_messages[key]);
            }

        }
    },
    watch: {
        countryId: {
            immediate: true,
            handler() {
                return this.countryRepository.get(this.countryId, Shopware.Context.api).then((country) => {
                    this.country = country;
                });
            }
        },
        languageId:{
            immediate: true,
            handler() {
                return this.languageRepository.get(this.languageId, Shopware.Context.api).then((language) => {
                    this.language = language;
                });
            }
        }
    }
});
